import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import enGB from 'date-fns/locale/en-GB';
import is from 'date-fns/locale/is';
import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { Datepicker } from '../../../components/icons';
import { Input } from '../Input';
import type { InputProps } from '../Input';

const InputHost = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;

  & input {
    overflow: hidden;
    width: 100%;
  }

  .react-datepicker-popper {
    z-index: 10;
  }

  svg:hover path {
    fill: #cee1ea;
  }
`;

const IconContainer = styled.div`
  position: absolute;
  z-index: 9;
  right: 21px;
  top: 50%;
  pointer-events: none;
`;

const DatePicker = styled(ReactDatePicker)``;

type InputWithoutValue = Omit<InputProps, 'value' | 'onChange'>;

export interface IProps extends InputWithoutValue {
  id: string;
  value?: Date;
  onChange: (value: Date) => void;
  filterDate?: (date: Date) => boolean;
  includeDates?: Date[];
}

export const DateInput: React.FC<IProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
  filterDate,
  includeDates,
  ...rest
}: IProps) => {
  const [hover, setHover] = useState(false);
  const [active, setActive] = useState(false);
  const { locale } = useResource();

  return (
    <InputHost
      {...rest}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <DatePicker
        disabled={disabled}
        selected={value}
        placeholderText={placeholder}
        onChange={(val) => onChange(val as Date)}
        onFocus={() => setActive(true)}
        onBlur={() => setActive(false)}
        filterDate={filterDate}
        includeDates={includeDates}
        customInput={<Input {...rest} />}
        dateFormat={locale === 'en' ? 'dd/MM/yyyy' : 'dd.MM.yyyy'}
        locale={locale === 'en' ? enGB : is}
      />

      <IconContainer>
        <Datepicker active={active} hover={hover} />
      </IconContainer>
    </InputHost>
  );
};
